import React from 'react'

import { boxShadowBig } from '@/_vars'
import { forceArray } from '@/lib/array-utils'
import { mainBlack, secondaryBlack, white } from '@/refactor/colors'
import { font, FontType } from '@/refactor/fonts'
import styled, { css, padPx } from '@/styles'
import { DefaultProps } from '@/travelsuit'

type BoxProps = DefaultProps & React.JSX.IntrinsicElements['div']

export interface IProps extends BoxProps {
	clickable?: boolean
	shouldHideShadow?: boolean
	useParentForHover?: boolean
	width?: number | string
	radius?: number | string | Array<number | string>
	padding?: number | number[]
	textColor?: string
	background?: string
	minWidth?: number | string
	maxWidth?: number | string
	noMargin?: boolean
}

const DEFAULT_RADIUS = 20

function isClickable({ onClick, clickable }: IProps): boolean {
	return Boolean(onClick || clickable)
}

export const transition = 'all 200ms ease-out'

/**
 * @deprecated use Card instead
 */
export const Box: React.ComponentType<React.PropsWithChildren<IProps>> = styled.div<IProps>`
	${({
		textColor: $textColor,
		background: $background,
		padding: $padding,
		noMargin: $noMargin,
		radius: $radius,
		width: $width,
		maxWidth: $maxWidth,
		minWidth: $minWidth,
		shouldHideShadow: $shouldHideShadow,
		...props
	}) => css`
		color: ${$textColor ?? mainBlack};
		background: ${$background ?? white};
		padding: ${forceArray($padding ?? 20)
			.map(padPx)
			.join(' ')};
		margin-bottom: ${$noMargin ? 0 : '20px'};
		transition: ${transition};
		border-radius: ${forceArray($radius ?? DEFAULT_RADIUS)
			.map((r) => padPx(typeof r === 'boolean' ? (r ? DEFAULT_RADIUS : 0) : r))
			.join(' ')};
		${$width ? `width: ${padPx($width)};` : ''}
		${$maxWidth ? `max-width: ${padPx($width)};` : ''}
    ${$minWidth ? `min-width: ${padPx($width)};` : ''}
    ${!$shouldHideShadow &&
		isClickable(props) &&
		css`
			&:hover {
				box-shadow: ${boxShadowBig};
			}
		`}
        cursor: ${isClickable(props) ? 'pointer' : ''};
	`}
`

interface BoxTitleProps {
	bottomMargin?: number | string
}

export const BoxTitle = styled.h3<BoxTitleProps>`
	${font(FontType.Comfortaa, { size: 20, weight: 'bold' })};
	color: ${mainBlack};
	margin-bottom: ${(props) => padPx(props.bottomMargin || 10)};
`

export const BoxSubtitle = styled.h4<BoxTitleProps>`
	${font({ size: 14 })};
	margin-bottom: ${(props) => padPx(props.bottomMargin || 40)};
	color: ${secondaryBlack};
`

export default Box
